module.exports = __webpack_public_path__ + "img/customerLogo13.63bb9c3b.png";